module.exports = __webpack_public_path__ + "static/wholesale-product-6667ac452bf487f4cdeb3a44cfc7810c.png";